{
  "name": "quality-assurance",
  "hostname": "qa.serveport.com",
  "development": true,
  "production": false,
  "applicationName": "ServePort",
  "sourceVersion": "2cd937cb6b866dbd3b868975d0da58cbe239783c",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.qa.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.qa.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.qa.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.qa.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-qa.auth0.com",
    "clientId": "BKDju9RPeR0vRALU2mkwOMOCAgI4ceXl",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.qa.serveport.com/_api/maintenance/",
    "code": "o33J6l83lG-HUvterNqfuIAfeJcqvqnNN2s-bvpGqEtvAzFuTio3nQ==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "6045357b-2709-490a-be56-96229bca203a"
    },
    "appInsights": {
      "instrumentationKey": "63b5b902-5193-4a8a-b14e-db55e9eee613"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 25
    },
    "reports": {
      "key": "Z7V2-XIA84H-5B4B5R-0U483J-2E5P0D-6E2L5X-3M284X-0Z0W1X-531H21-6W2X0F"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
